import { Button, Form, Input, Select, Switch, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { Link, useParams, useLoaderData, useOutletContext, useNavigate } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { RxUpdate } from "react-icons/rx";
import EventEmitter from '../../utils/eventEmitter';
import useContactTagAPI from '../apis/contactTagAPI';



const TagChanges = () => {
  const tag = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  // const [name, setName] = useState(tag.name ? tag.name : '');
  const { create, update } = useContactTagAPI();
  


  // const onChangeName = (e) => setName(e.target.value);

  const save = () => {
    let data = form.getFieldsValue();
    // data['name'] = name;
    // data['seo'] = name.toLowerCase().replace(/ /g, '-');
    create(data, success);
    // console.log(data);
  }

  const edit = () => { 
    let data = form.getFieldsValue();
    // data['name'] = name;
    // data['seo'] = name.toLowerCase().replace(/ /g, '-');
    update(tag.seo, data,success);
  };

  useEffect(() => {
    EventEmitter.subscribe('tag_created', data => {
      navigate('/contact/tags/'+data);
    });
    
    return () => EventEmitter.unsubscribe('tag_created');
  },[])

  return (
    <div className='container mx-auto' style={{ maxWidth: '1000px' }}>
      <div className='flex justify-between'>
        <div>
          <h3 className='font-bold'>
            <Link to={'/contact/tags'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Tags</Link> / {params.action}
            <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={save} type='text' htmlType='button'
              disabled={tag.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={edit} type='text' htmlType='button'
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
          </h3>
          {tag.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
        </div>
        
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        {/* <FloatingLabel
          name='name'
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Warehouse Name"
          value={name} 
          onChange={onChangeName}
        /> */}
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 5 }}
          labelWrap={true}
          initialValues={tag.seo ? tag : {}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Form.Item label='Name' name="name" className='font-bold mb-2 column' required >
            <Input className='border-x-0 border-t-0 input-outline-none font-normal' />
          </Form.Item>
        
          <Form.Item label='parent' name="parent" className='font-bold mb-2 column' required >
            <Select />
          </Form.Item>
          
          <Form.Item label='Active' name="active" className='font-semibold text-gray-800 mb-3 column' required >
            <Switch />
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default TagChanges;